import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core'
import { MenuItem } from 'primeng/api'

@Component({
  selector: 'basin-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
})
export class ChipComponent {
  @Input() label: string
  @Input() icon: string
  @Input() removable: boolean
  @Input() onlyMarkForRemoval: boolean = false
  @Input() markedToRemove: boolean = false
  @Input() removed: boolean = false
  @Output() removedChange = new EventEmitter<Event>()
  @Input() toggleType: 'toggle' | 'switch'
  @Input() active: boolean = false
  @Input() iconClickable: boolean = true
  @Output() iconClick = new EventEmitter<Event>()
  @Input() activeSwitch: string
  @Output() activeChange = new EventEmitter<boolean>()
  @Output() splitActionLeftEvent = new EventEmitter()
  @Input() splitActionRightIcon: string
  @Input() splitActionRightLabel: string
  @Output() splitActionRightEvent = new EventEmitter()
  @Input() splitActionMiddleIcon: string
  @Input() splitActionMiddleLabel: string
  @Output() splitActionMiddleEvent = new EventEmitter()
  @Input() splitActionMenuItems: MenuItem[]
  @Input() isDropdownChip: boolean = false
  @Output() dropdownExpandedChange = new EventEmitter<boolean>()

  dropdownExpanded: boolean = false

  constructor(private readonly elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement
    if (
      this.isDropdownChip &&
      !this.elementRef.nativeElement.contains(target)
    ) {
      this.dropdownExpanded = false
      this.dropdownExpandedChange.emit(this.dropdownExpanded)
    }
  }

  handleIconClick(event) {
    if (!this.iconClickable) return
    event.stopPropagation()
    this.iconClick.emit(event)
  }

  handleActionLeft() {
    if (this.toggleType === 'toggle') {
      this.active = !this.active
      this.activeChange.emit(this.active)
    }
    if (this.toggleType === 'switch') {
      this.activeSwitch = 'left'
      this.splitActionLeftEvent.emit()
    }
  }

  removeChip(event: Event) {
    event.stopPropagation()
    if (this.onlyMarkForRemoval) {
      this.markedToRemove = !this.markedToRemove
    } else {
      this.removed = true
    }
    this.removedChange.emit(event)
  }

  handleActionRight() {
    if (this.toggleType === 'switch') {
      this.activeSwitch = 'right'
    }
    this.splitActionRightEvent.emit()
  }

  handleActionMiddle() {
    if (this.toggleType === 'switch') {
      this.activeSwitch = 'middle'
    }
    this.splitActionMiddleEvent.emit()
  }

  toggleDropdown() {
    this.dropdownExpanded = !this.dropdownExpanded
    this.dropdownExpandedChange.emit(this.dropdownExpanded)
  }
}
